import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { Image } from '@cian/ui-kit';
import * as React from 'react';

import { useGetContent } from './hooks';
import { trackShowPromoBanner } from './tracking';
import { PromoBannerLayout } from '../../components/PromoBanner';
import { VIEWED_TIMEOUT } from '../../constants/timeouts';
import { useTrackingParams } from '../../hooks/useTrackingParams';
import { MainButtonsContainer } from '../MainButtonsContainer';

interface IPromoBannerContainerProps {
  mainButtonsRef?: React.Ref<HTMLDivElement>;
}

export const PromoBannerContainer: React.FC<IPromoBannerContainerProps> = ({ mainButtonsRef }) => {
  const { siteType } = useTrackingParams();

  const { heading, title, theme, background } = useGetContent();

  return (
    <ActionAfterViewObserver callback={() => trackShowPromoBanner(siteType)} callbackDelay={VIEWED_TIMEOUT}>
      <PromoBannerLayout
        mainButtonsRef={mainButtonsRef}
        heading={heading}
        title={title}
        theme={theme}
        background={<Image src={background} />}
        buttons={<MainButtonsContainer />}
      />
    </ActionAfterViewObserver>
  );
};
